import styled from 'styled-components';

const EntityWrapper = styled.div``;


export default EntityWrapper;